/* tslint:disable */
/* eslint-disable */
/**
 * WeWalk API V2.0
 * Backend service for WeWALK Mobile Applications, written in **TypeScript** and runs on **NodeJS**. Using **MongoDB** for database, **mongoose** for ORM, **Redis Cache** for caching auth tokens. In cloud, runs in Azure App Services (wewalk-backend-v2). For cloud database, it uses MongoDB inside Azure Cosmos DB. For passwordless authentication, Firebase Authentication is used, other than that, users can use email-password sign-in as well. Transportation services are fed by [Azure Maps Mobility Services](https://docs.microsoft.com/en-us/rest/api/maps/mobility) [RAW JSON](/api/v2/documentation) - [Swagger Editor](https://editor.swagger.io) <br><br> Production Service Health: <img src='https://dev.azure.com/wewalksmartcane/wewalk-api-v2/_apis/build/status/wewalk-api-v2-CI'/> <br><br>Test Service Health: <img src='https://dev.azure.com/wewalksmartcane/wewalk-api-v2/_apis/build/status/wewalk-api-v2-CI-staging'/>
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { ClientSettingsResponse } from '../models';
import { EmptyRequest } from '../models';
import { ErrorModelResponse } from '../models';
/**
 * ClientSettingsApi - axios parameter creator
 * @export
 */
export const ClientSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all client setting's value (settings like CLIENT_SETTING_XXXXX)
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSettingsGetAllPost: async (body: EmptyRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling clientSettingsGetAllPost.');
            }
            const localVarPath = `/clientSettings/getAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all client setting's value (settings like CLIENT_SETTING_XXXXX)
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSettingsGetPost: async (body: EmptyRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling clientSettingsGetPost.');
            }
            const localVarPath = `/clientSettings/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientSettingsApi - functional programming interface
 * @export
 */
export const ClientSettingsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets all client setting's value (settings like CLIENT_SETTING_XXXXX)
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientSettingsGetAllPost(body: EmptyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSettingsResponse>> {
            const localVarAxiosArgs = await ClientSettingsApiAxiosParamCreator(configuration).clientSettingsGetAllPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Gets all client setting's value (settings like CLIENT_SETTING_XXXXX)
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientSettingsGetPost(body: EmptyRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientSettingsResponse>> {
            const localVarAxiosArgs = await ClientSettingsApiAxiosParamCreator(configuration).clientSettingsGetPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ClientSettingsApi - factory interface
 * @export
 */
export const ClientSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Gets all client setting's value (settings like CLIENT_SETTING_XXXXX)
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSettingsGetAllPost(body: EmptyRequest, options?: any): AxiosPromise<ClientSettingsResponse> {
            return ClientSettingsApiFp(configuration).clientSettingsGetAllPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all client setting's value (settings like CLIENT_SETTING_XXXXX)
         * @param {EmptyRequest} body Empty request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientSettingsGetPost(body: EmptyRequest, options?: any): AxiosPromise<ClientSettingsResponse> {
            return ClientSettingsApiFp(configuration).clientSettingsGetPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientSettingsApi - object-oriented interface
 * @export
 * @class ClientSettingsApi
 * @extends {BaseAPI}
 */
export class ClientSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Gets all client setting's value (settings like CLIENT_SETTING_XXXXX)
     * @param {EmptyRequest} body Empty request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientSettingsApi
     */
    public clientSettingsGetAllPost(body: EmptyRequest, options?: any) {
        return ClientSettingsApiFp(this.configuration).clientSettingsGetAllPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Gets all client setting's value (settings like CLIENT_SETTING_XXXXX)
     * @param {EmptyRequest} body Empty request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientSettingsApi
     */
    public clientSettingsGetPost(body: EmptyRequest, options?: any) {
        return ClientSettingsApiFp(this.configuration).clientSettingsGetPost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
